import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "theme-preview" }

import { reactive } from "vue";

// Theme type definition
interface Theme {
  background: string;
  primary: string;
  secondary: string;
  text: string;
}

// Generate a random hex color

export default /*@__PURE__*/_defineComponent({
  __name: 'TRTheme',
  setup(__props) {

const getRandomColor = (): string => {
  return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0")}`;
};

// Helper function to generate a random number in a range
const getRandomInRange = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Generate a harmonious color in HSL
const generateHSLColor = (hue: number, saturation: number, lightness: number): string => {
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

// Generate a harmonious theme
const generateRandomTheme = (): Theme => {
  // Base hue for harmony
  const baseHue = getRandomInRange(0, 360);

  return {
    "--color-primary": generateHSLColor(baseHue, 50, 50),
    "--color-secondary": generateHSLColor((baseHue + 30) % 360, 40, 60), // Analog
    "--color-customRed": generateHSLColor((baseHue + 180) % 360, 70, 50), // Complementary
    "--color-customGreen": generateHSLColor((baseHue + 120) % 360, 60, 40), // Triadic
    "--color-customBlue": generateHSLColor((baseHue + 240) % 360, 60, 40), // Triadic
    "--color-active": generateHSLColor(baseHue, 70, 45),
    "--color-inactive": generateHSLColor(baseHue, 20, 80),
    "--color-header": generateHSLColor((baseHue + 10) % 360, 50, 55),
    "--color-white": "#ffffff", // Weiß bleibt konstant
    "--color-black": "#000000", // Schwarz bleibt konstant
    "--color-bg-opacity-50": `hsla(${baseHue}, 50%, 50%, 0.5)`,
    "--color-trader-title-bar": generateHSLColor(baseHue, 50, 50),
    "--color-trader-background": generateHSLColor(baseHue, 30, 90),
    "--color-trader-hover-text": generateHSLColor(baseHue, 90, 20),
    "--color-trader-hover-background": generateHSLColor(baseHue, 80, 40),
    "--color-trader-light-gray": generateHSLColor(baseHue, 10, 90),
    "--color-trader-gray": generateHSLColor(baseHue, 10, 80),
    "--color-trader-dark-gray": generateHSLColor(baseHue, 20, 70),
    "--color-trader-darker-gray": generateHSLColor(baseHue, 30, 60),
    "--color-trader-darkest-gray": generateHSLColor(baseHue, 40, 50),
    "--color-trader-text": generateHSLColor(baseHue, 30, 20),
    "--color-trader-input-border": generateHSLColor(baseHue, 30, 50),
    "--color-trader-blue": generateHSLColor((baseHue + 240) % 360, 60, 50),
    "--color-trader-green": generateHSLColor((baseHue + 120) % 360, 50, 40),
    "--color-trader-dark-green": generateHSLColor((baseHue + 120) % 360, 50, 30),
    "--color-trader-orange": generateHSLColor((baseHue + 30) % 360, 70, 50),
    "--color-trader-dark-orange": generateHSLColor((baseHue + 30) % 360, 80, 40),
    "--color-trader-red": generateHSLColor((baseHue + 180) % 360, 70, 50),
    "--color-trader-dark-red": generateHSLColor((baseHue + 180) % 360, 70, 40),
    "--color-trader-signal-red": generateHSLColor((baseHue + 180) % 360, 70, 30),
    "--color-trader-market-blue": generateHSLColor((baseHue + 240) % 360, 70, 50),
    "--color-trader-market-green": generateHSLColor((baseHue + 120) % 360, 70, 50),
    "--color-trader-market-red": generateHSLColor((baseHue + 180) % 360, 70, 50),
    "--color-indesign-light": generateHSLColor(baseHue, 60, 70),
    "--color-indesign-dark": generateHSLColor(baseHue, 80, 30),
    "--color-electron-title-bar": generateHSLColor(baseHue, 40, 40),
    "--color-electron-background": generateHSLColor(baseHue, 30, 90),
    "--color-trader-highlight": generateHSLColor(baseHue, 80, 70),
  };
};

// Apply the theme to the document body
const applyTheme = (theme: Theme) => {
  const root = document.documentElement;
  Object.keys(theme).forEach((key) => {
    root.style.setProperty(key, theme[key]);
  });
};

// Reactive theme state
const theme = reactive<Theme>(generateRandomTheme());



// Generate a new theme and apply it
const generateTheme = () => {
  const newTheme = generateRandomTheme();
  Object.assign(theme, newTheme);
  applyTheme(newTheme);
};

// Apply the initial theme
applyTheme(theme);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: generateTheme,
      class: "apply-theme-btn"
    }, " Generate Random Theme "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("Background: ")),
        _createElementVNode("span", null, _toDisplayString(theme.background), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[1] || (_cache[1] = _createTextVNode("Primary: ")),
        _createElementVNode("span", null, _toDisplayString(theme.primary), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode("Secondary: ")),
        _createElementVNode("span", null, _toDisplayString(theme.secondary), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createTextVNode("Text: ")),
        _createElementVNode("span", null, _toDisplayString(theme.text), 1)
      ])
    ])
  ]))
}
}

})